import { NavLink,Link } from 'react-router-dom'
import React, { useEffect } from "react";
import { XIcon } from '@heroicons/react/solid'

export default function Navbar() {

    useEffect(() => {

        const menuButton = document.getElementById('menuButton');
        
        menuButton.addEventListener('click', function () {
            let classList = document.getElementById('menu-mobiles')
            classList.classList.toggle('hidden');
            classList.classList.toggle('block');
        });
        
        const drawerMask = document.getElementById("drawer-mask");
        drawerMask.addEventListener('click', function () {
            let classList = document.getElementById('menu-mobiles')
            classList.classList.toggle('hidden')
            classList.classList.toggle('block')
        });

        const CloseMenu = document.getElementById("btnCloseMenu");
        CloseMenu.addEventListener('click', function () {
            let classList = document.getElementById('menu-mobiles')
            classList.classList.toggle('hidden')
            classList.classList.toggle('block')
        });

        const CloseMenuMovil = document.querySelectorAll(".menuMovil");
        CloseMenuMovil.forEach(item => {
            item.addEventListener('click', function handleClick(event) {
                let classList = document.getElementById('menu-mobiles')
                classList.classList.toggle('hidden')
                classList.classList.toggle('block')
            });
          }); 
    },[]);

    return(
        <>
            <nav className='container shadow-md flex justify-between items-center h-20 bg-white relative shadow-sm' role='navigation'>
                <Link to='/Inicio'><img src='/images/logo.png' alt='logo Viajes Manguen' className='w-full h-20' ></img></Link>
                <div id='menuButton' className="px-4 cursor-pointer md:hidden">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
                    </svg>
                </div>
                <div id='navItems' className='pr-8 md:block hidden'>
                    <NavLink to='/Inicio' className={isActive =>' px-4 text-gray-600 hover:text-blue-600' + (isActive ? " MenuActive" : "")}>Inicio</NavLink>
                    <NavLink to='/Servicios' className={isActive => 'px-4 text-gray-600 hover:text-blue-600'+ (isActive ? " MenuActive" : "")}>Servicios</NavLink>
                    <NavLink to='/Nosotros' className={isActive => 'px-4 text-gray-600 hover:text-blue-600'+ (isActive ? " MenuActive" : "")}>Nosotros</NavLink>
                    <NavLink to='/Paquetes' className={isActive => 'px-4 text-gray-600 hover:text-blue-600'+ (isActive ? " MenuActive" : "")}>Paquetes</NavLink>
                    <NavLink to='/Vivencias' className={isActive => 'px-4 text-gray-600 hover:text-blue-600'+ (isActive ? " MenuActive" : "")}>Vivencias</NavLink>
                    {/* <NavLink to='/Contacto' className={isActive => 'px-4 text-gray-600 hover:text-blue-600'+ (isActive ? " MenuActive" : "")}>Contacto</NavLink> */}
                </div>
            </nav>
            
            <div id="menu-mobiles" className='hidden'>
                <div tabIndex={-1} className="drawer drawer-right drawer-open" style={{ "touchAction": "pan-y"}}>
                    <div id="drawer-mask" className="drawer-mask"></div>
                    <div className="drawer-content-wrapper  bg-white" style={{width: "320px"}}>
                        <div className="drawer-content">
                            <div data-testid="accordion-wrapper" data-reach-accordion="">
                                <div index="0">
                                    <div data-testid="reach-accordion-item" className="grid grid-cols-2 gap-4 px-4" data-reach-accordion-item="" data-state="collapsed">
                                        <button id="btnCloseMenu" className="w-full flex justify-between items-center focus:outline-none py-4" data-reach-accordion-button="" data-state="collapsed">
                                            <XIcon className='h-6 w-6'></XIcon>
                                        </button>
                                        <div className='flex justify-end items-center px-4'>
                                        </div>
                                    </div>
                                </div>
                                <div index="1">
                                    <div data-testid="reach-accordion-item" className="flex flex-col px-5 py-3">
                                        <NavLink to='/Inicio' className={isActive =>'px-4 text-black-600 font-medium menuMovil' + (isActive ? " MenuActive" : "")}>Inicio</NavLink>
                                    </div>
                                </div>
                                <div index="2">
                                    <div data-testid="reach-accordion-item" className="flex flex-col px-5 py-3">
                                        <NavLink to='/Servicios' className={isActive => 'px-4 text-black-600 font-medium menuMovil'+ (isActive ? " MenuActive" : "")}>Servicios</NavLink>
                                    </div>
                                </div>
                                <div index="3">
                                    <div data-testid="reach-accordion-item" className="flex flex-col px-5 py-3">
                                        <NavLink to='/Nosotros' className={isActive => 'px-4 text-black-600 font-medium menuMovil'+ (isActive ? " MenuActive" : "")}>Nosotros</NavLink>
                                    </div>
                                </div>
                                <div index="4">
                                    <div data-testid="reach-accordion-item" className="flex flex-col px-5 py-3">
                                        <NavLink to='/Paquetes' className={isActive => 'px-4 text-black-600 font-medium menuMovil'+ (isActive ? " MenuActive" : "")}>Paquetes</NavLink>
                                    </div>
                                </div>
                                <div index="5">
                                    <div data-testid="reach-accordion-item" className="flex flex-col px-5 py-3">
                                        <NavLink to='/Vivencias' className={isActive => 'px-4 text-black-600 font-medium menuMovil'+ (isActive ? " MenuActive" : "")}>Vivencias</NavLink>
                                    </div>
                                </div>
                                {/* <div index="6">
                                    <div data-testid="reach-accordion-item" className="flex flex-col px-4" data-reach-accordion-item="" data-state="collapsed">
                                        <NavLink to='/Contacto' className={isActive => 'px-4 text-black-600 font-medium menuMovil'+ (isActive ? " MenuActive" : "")}>Contacto</NavLink>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}